import { get, isObject, isString } from 'lodash';
import { toast } from '@oliasoft-open-source/react-ui-library';
import {
  BAD_REQUEST,
  CONFLICT,
  FORBIDDEN,
  GONE,
  NOT_FOUND,
  SERVER_ERROR,
  UNAUTHORIZED_STATUS
} from '~common/constants';
import { NAVIGATION_CONSTANTS, NotificationTypes } from '../constants';
import { history } from '../reduxStore';

export interface IApiValidationError {
  messages: string;
}

interface IApiErrorMessage {
  original?: { detail?: string };
  errors?: { message: string }[];
}

export interface IApiErrorBody {
  msg?: string | IApiErrorMessage;
}

export type TApiErrorData = string | IApiErrorBody | IApiValidationError[];

const showError = (content: string | undefined) => toast({
  message: {
    type: NotificationTypes.ERROR,
    heading: 'Error!',
    content,
  },
});

export default (status: number, data: TApiErrorData) => {
  const msg = typeof data === 'string' || Array.isArray(data) ? undefined : data.msg;

  if (status === UNAUTHORIZED_STATUS) {
    history.push(NAVIGATION_CONSTANTS.ROOT);

    return;
  }
  if (status === FORBIDDEN || status === NOT_FOUND || status === CONFLICT || status === GONE) {
    showError(isString(msg) ? msg : undefined);
    return;
  }

  if (status === SERVER_ERROR || status === BAD_REQUEST) {
    // AuthDB error single
    if (typeof data === 'string') {
      showError(data);
      return;
    }
    if (msg && isObject(msg) && !msg.errors) {
      showError(get(msg, 'original.detail', 'Something went wrong'));
      return;
    }
    if (isString(msg)) {
      showError(msg);
      return;
    }

    if (Array.isArray(data)) {
      // Handles all errors from validations
      for (const err of data) {
        showError(err.messages);
      }
      return;
    }

    // Sequelize and  AuthZ errors
    if (isObject(msg) && Array.isArray(msg.errors)) {
      for (const err of msg.errors) {
        showError(err.message);
      }
    }
  }
};
